import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/team/report_individual_table.js
const ReportTableIndividual = (props) => {

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.userReportData.breakdown)
  }

  const getTableData = () => {
    let tableData = []
    let tmp = props.tableData && props.tableData[0] && props.tableData[0].stats ? props.tableData[0].stats : props.tableData
    tmp.forEach((data) => {
      if (data.prospect_billable > 0 || data.ev_billable > 0 || data.ef_billable > 0 || data.js_widget_billable > 0 || data.data_pulse_billable > 0) {
        tableData.push(data)
      }
    })

    return tableData
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('-')

  const columns = [
    {
      dataField: 'date',
      text: 'Day',
      formatter: dateFormatter,
      headerStyle: { width: '14%' },
      style: { width: '14%' },
    },
    {
      dataField: 'total',
      text: 'Total',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total'
    },
    {
      dataField: 'ev_billable',
      text: 'Email Verifier',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Verifier'
    },
    {
      dataField: 'ef_billable',
      text: 'Email Finder',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Finder'
    },
    {
      dataField: 'prospect_billable',
      text: 'Prospect',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'js_widget_billable',
      text: 'Form Guard',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'data_pulse_billable',
      text: 'Data Pulse',
      headerStyle: { width: '14%' },
      style: { width: '14%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div className="report-table">
      <ReportTable
        keyField="date"
        data={data}
        columns={columns}
        wrapperClasses="table-report table-responsive"
        noDataIndication={noDataIndication}
      />
    </div>
  )
}

export default ReportTableIndividual
